import React from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';
import classNames from 'classnames';
import {
  components as DefaultSelectComponents,
  OptionProps,
} from 'react-select';
import { SelectOption } from '@lib/components/Select/types';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Chip, { ChipSizes, ChipTypes } from '@lib/components/Chip/Chip';
import styles from '../Select.module.scss';

export default function TaskWithFormTemplateVersionOption({
  children,
  ...restProps
}: OptionProps): React.ReactElement {
  const { isSelected, isMulti, options } = restProps;
  const value = _get(restProps, 'value', '');
  const selectedOption = _find(
    options,
    ({ value: optionValue }) => value === optionValue,
  ) as SelectOption;
  const { data } = selectedOption || {};
  const version = _get(data, 'formTemplateVersion.version');
  return (
    // @ts-ignore
    <DefaultSelectComponents.Option
      {...restProps}
      className={classNames(styles.entityOption, {
        active: isSelected,
        [styles.optionWithCheckbox]: isMulti,
      })}
    >
      {isMulti && (
        <span className={styles.optionCheckbox}>
          <MaterialIcon
            icon={isSelected ? 'check_box' : 'check_box_outline_blank'}
            size="md-18"
          />
        </span>
      )}
      <span className={styles.entityOptionLabelWrap}>
        <span
          className={classNames(
            styles.entityOptionLabel,
            styles.entityOptionLabelWidthRightIcon,
          )}
        >
          <span className={styles.entityOptionLabelText}>{children}</span>
          {version && (
            <Chip
              type={ChipTypes.chipGreen}
              size={ChipSizes.small}
              label={`v${version}`}
            />
          )}
        </span>
      </span>
    </DefaultSelectComponents.Option>
  );
}
